var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.8502,
    height: 28.8491,
    rx: 4,
    transform: "matrix(0.999997 -0.00257016 0.00132854 0.999999 0.388428 0.497559)",
    fill: "#464E5F",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.50842 20.4048C7.89514 18.7368 7.92249 16.0845 9.53577 14.4438L15.278 8.56494C16.4811 7.33447 18.4498 7.33447 19.6803 8.56494C20.8561 9.79541 20.8834 11.7915 19.6803 13.022L14.6764 18.1353C13.8561 18.9556 12.5162 18.9556 11.7233 18.1079C10.9303 17.2876 10.9576 15.9751 11.7506 15.1821L15.6881 11.1626C15.8522 10.9985 16.1256 10.9712 16.317 11.1626L16.9186 11.7642C17.11 11.9282 17.11 12.2017 16.9459 12.3931L13.0084 16.3853C12.8717 16.522 12.8717 16.7681 12.9811 16.9048C13.1178 17.0142 13.3092 17.0142 13.4186 16.9048L18.4225 11.7915C18.942 11.2446 18.942 10.3423 18.4225 9.79541C17.903 9.27588 17.0553 9.27588 16.5358 9.79541L10.7936 15.6743C9.83655 16.6313 9.83655 18.2173 10.7662 19.1743C11.6959 20.1313 13.1998 20.1313 14.1295 19.1743L18.8326 14.3618C18.9967 14.1978 19.2701 14.1978 19.4342 14.3618L20.0631 14.9907C20.2545 15.1548 20.2545 15.4282 20.0905 15.5923L15.3873 20.4048C13.7467 22.0728 11.1217 22.0454 9.50842 20.4048Z",
    fill: "#464E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachment-icon.33faff554c94fa798afd9e84f5e2c0c9.svg";
export { ForwardRef as ReactComponent };